<template>
  <div
    v-show="value"
    :class="b()"
    @touchstart="onTouchStart"
    @touchmove.prevent="touchMove"
    @touchend="onTouchEnd"
    @touchcancel="onTouchEnd"
    @click='onPcClose'
  >
    <swipe :initial-swipe="startPosition">
      <swipe-item v-for="(item, index) in images" :key="index">
        <img @dbclick='onDbclickImg'
        :class="b('image')" :src="item" >
        <div :class="b('actions')"
        v-if='showDeleteActions'>
          <Button
          @click.stop='onClickAction(item)'>删除</Button>
        </div>
        <div :class="b('icon')"
        v-if='isShowSlider'>
          <Icon :class="b('icon-left')"
          name='chevron-circle-left'
          @click.stop='onClickSliderIcon("left")'></Icon>
          <Icon :class="b('icon-right')"
          name='chevron-circle-right'
          @click.stop='onClickSliderIcon("right")'></Icon>
        </div>
      </swipe-item>
    </swipe>
  </div>
</template>

<script>
import create from '../utils/create';
import Popup from '../mixins/popup';
import Swipe from '../carousel';
import SwipeItem from '../carousel-item';
import Touch from '../mixins/touch';
import Button from '../button'
import Icon from '../icon'
import {userAgentUtil} from "jscom/utils/UserAgentUtil"

export default create({
  name: 'image-preview',

  mixins: [Popup, Touch],

  components: {
    Swipe,
    SwipeItem,
    Button,
    Icon
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: true
    },
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isShowSlider () {
      return !(userAgentUtil.isIphone() || userAgentUtil.isAndroid()) && this.images.length > 1
    }
  },

  data() {
    return {
      images: [],
      startPosition: 0
    };
  },
  methods: {
    onTouchStart(event) {
      this.touchStartTime = new Date();
      this.touchStart(event);
    },
    onPcClose () {
      if (event.target.tagName === 'BUTTON' || event.target.tagName === 'I') {
        return
      }
      this.$emit('input', false)
    },
    onClickAction (item) {
      this.onClickDeleteActions(item)
    },
    onDbclickImg () {
    },
    onClickSliderIcon (site) {
      let maxIndex = this.images.length - 1
      if (site === 'left') {
        this.startPosition = this.startPosition > 0 ? this.startPosition - 1 : 0 
      } else {
        this.startPosition = this.startPosition === maxIndex ? maxIndex : this.startPosition + 1
      }
    },

    onTouchEnd(event) {
      if (event.target.tagName === 'BUTTON' || event.target.tagName === 'I') {
        return
      }
      event.preventDefault();
      // prevent long tap to close component
      const deltaTime = new Date() - this.touchStartTime;
      if (deltaTime < 200 && this.offsetX < 50 && this.offsetY < 50) {
        this.$emit('input', false);
      }
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/image-preview/image-preview.vue